
import Api from '@/utils/api';
import Toast from 'vux/src/components/toast/index.vue'
import querystring from 'vux/src/tools/querystring/index.js'


export default {
data() {
return {
is_fav: 0,
toastText: "加入成功",
show1: false,
isFavorite: false,
quantity: '1'
}
},
methods: {
openShoppCart(msg, valid) {







this.$store.commit('updateShoppPopup', {
isTrue: true,
shoppOpenType: msg
});
},
addProductToCart (res) {
Api.addProductToCart({
product: res._id
}).then(res => {
if (res.data.error) {
console.error(res)
return
}
this.toastText = '加入购物车成功'
this.show1 = true
Api.getCartCount()
})
},
toShoppCart() {
this.$router.push({
name: 'shoppCart'
})
},
goCreateOrder() {
const that = this
this.$router.push({
name: 'createOrder',
query: {
products: JSON.stringify([that.res])
}
})
},
addFavorite() {
Api.addFavorite({
product: this.res._id
}).then(res => {
this.toastText = '收藏成功'
this.show1 = true
this.isFavorite = true
})
},
deleteFavorite() {
Api.deleteFavorite(this.res._id).then(res => {
this.toastText = '取消收藏成功'
this.show1 = true
this.isFavorite = false
})
}
},
mounted() {
Api.getIsFavorite(this.res._id).then(res => {
console.log(res)
this.isFavorite = res.data.isFavorite
console.log(this.isFavorite)
})

},
computed: {
shopNum() {
return this.$store.state.cartCount.number != 0 ? true : false;
}
},
components: {
Toast
},
props: ['id', 'res']

}



// WEBPACK FOOTER //
// ./src/components/Detail/Footer.vue